export const redirect = () => {
  if (!window.location.host.includes("localhost")) {
    if (!window.location.protocol.includes("s")) {
      window.location.replace(
        `https://${window.location.host}${
          window.location.pathname.length > 1
            ? `/${window.location.pathname}`
            : ""
        }`,
      );
    }
  }
};

export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
};

export const validatePassword = (password) => {
  return String(password).match(
    /^.*(?=.{8,})(?=.*[a-zA-Z])(?=.*\d)(?=.*[!#$%&? "]).*$/,
  );
};

export const passwordValidateErrorMessage =
  "Password must be at least 8-chracters long, has one uppercase letter, one lowercase letter, and one special character!";

export const requiredFieldsErrorMessage =
  "Fields marked with ( * ) are required!";

export const volunteerApplicationSuccessMessage =
  "Thank you for your Volunteer Application! Our team has received your submission. We will contact you as soon as possible.";

export const volunteerApplicationFailureMessage =
  "Failed to send the application! Please try again!";

export const bullets = [
  "Responsibilities",
  "Skills Required",
  "Skills gained",
  "Training provided by",
  "Commitment",
];

export const skills = [
  {
    title: "Heritage Interpreter",
    items: [
      "Provide guided tours of the PEH property, working with the Volunteer Coordinator to provide visitors with a welcoming and informative experience. This may include doing some independent research on the history of the house to better inform visitors. The Heritage Interpreter may also be asked to assist with the set-up and take-down of exhibits.",
      "Comfortable with public speaking and an interest in local history. This role also requires the physical stamina to lead walking tours over the course of a couple hours.",
      "Increased knowledge of local history. Instruction on how to handle artefacts. Experience in guiding/storytelling and working to educate the public.",
      "Volunteer and Visitor Experience Coordinator",
      "Minimum 8 hours (2 shifts)/month",
    ],
  },
  {
    title: "Garden Volunteer",
    items: [
      "Assist with care and maintenance of the Point Ellice House gardens/grounds. Working with our Heritage Gardens Manager and other garden volunteers, individuals will learn about the history of Victorian and Edwardian gardening and help to propagate plants, collect seeds, and maintain and restore elements of the gardens.",
      "Ability to work in a team. Knowledge of basic gardening techniques / previous gardening experience is an asset.",
      "Increased knowledge of heritage gardens. Increased knowledge of gardening techniques and plant identification. Ongoing garden training and the potential for workshops if there is interest.",
      "Heritage Gardens Manager",
      "Currently meeting every Wednesday 8:30 am - 12pm, ideally a minimum of 12 hours (3 shifts)/month",
      "We are also seeking someone passionate about lawn care! We are seeking someone interested in helping us mow our heritage lawns. If this is a specific interest of yours, please let us know!",
    ],
  },
  {
    title: "Research Assistant",
    items: [
      "Assist with research projects related to the collection, working with the Museum Manager to catalogue and document artifacts and fact-check our information. May also assist with office tasks such as filing and data entry.",
      "Good attention to detail and critical thinking. Experience working with academic sources and citations, and handling museum collections would be considered an asset.",
      "Increased knowledge of local history, training on how to properly handle historical artifacts and experience with conducting academic research.",
      "Museum Manager",
      "Minimum of 8 hours (2 shifts)/month",
    ],
  },
];

export const interests = [
  "Taking photos/videos",
  "Assisting with events",
  "Basic Maintenance",
];

export const contactMethods = ["Text", "Call", "Email"];
